import FeltoltesAdatlapTableService from 'app/admin/feltoltesadatlap/service/FeltoltesAdatlapTableService';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import FeltoltesAdatlapDeleteButton from './FeltoltesAdatlapDeleteButton';
import FeltoltesAdatlapCloseButton from './FeltoltesAdatlapCloseButton';

const config = {
	key: 'feltoltesAdatlapTable',
	text: 'Feltöltés',
	textKey: 'uploadsheet',
	service: FeltoltesAdatlapTableService,
	icon: 'person',
	editFormState: item => `/feltoltesadatlap/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['filter', 'refresh', 'new'],
	filterFields: [
		{
			propertyName: 'csomagNev',
			propertyType: 'String',
			type: 'LIKE'
		}
	],
	rowButtonList: [
		{ key: 'close', component: FeltoltesAdatlapCloseButton, paperType: 'adatlap_kepek' },
		{ key: 'delete', component: FeltoltesAdatlapDeleteButton, paperType: 'adatlap_kepek' }
	],
	columns: [
		{
			key: 'csomagNev',
			text: 'Csomag neve',
			textKey: 'csomagNev',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'adatlapFilename',
			text: 'Fájl neve',
			textKey: 'adatlapFilename',
			type: 'text',
			sortable: true,
			disablePadding: false
		},
		{
			key: 'adatlapPath',
			text: 'Útvonal',
			textKey: 'adatlapPath',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function FeltoltesAdatlapTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('feltoltesAdatlapTable', reducer('feltoltesAdatlapTable'))(FeltoltesAdatlapTable);
